module.exports = __webpack_public_path__ + "c4e8d926.svg";